module.exports = __webpack_public_path__ + "img/logout.26256d1f.svg";